import React, { useEffect, useState } from "react";
import familyImg from "../../assets/images/globel.png";
import { API_CONFIG } from "../../config/apiConfig";

interface GlobalOpportunitiesProps {
  onApplyFilters?: (filters: { country: string; category: string }) => void;
  data?: any;
}

const GlobalOpportunities: React.FC<GlobalOpportunitiesProps> = ({ onApplyFilters, data }) => {
  const [countries, setCountries] = useState<string[]>([]);
  const [categories, setCategories] = useState<Array<{ name: string; slug: string }>>([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");

  useEffect(() => {
    const fetchFilterData = async () => {
      try {
        const [countriesRes, categoriesRes] = await Promise.all([
          fetch(`${API_CONFIG.BASE_URL}/jobs/countries`, { headers: API_CONFIG.HEADERS }),
          fetch(`${API_CONFIG.BASE_URL}/jobs/categories`, { headers: API_CONFIG.HEADERS }),
        ]);

        const countriesJson = await countriesRes.json();
        const categoriesJson = await categoriesRes.json();

        if (countriesJson.success) {
          setCountries((countriesJson.data || []).map((c: any) => c.country).filter(Boolean));
        }

        if (categoriesJson.success) {
          setCategories((categoriesJson.data || []).map((cat: any) => ({
            name: cat.name,
            slug: cat.slug,
          })));
        }
      } catch (error) {
        console.error("Filter data fetch error:", error);
      }
    };

    fetchFilterData();
  }, []);

  const handleApply = () => {
    onApplyFilters?.({ country: selectedCountry, category: selectedCategory });
  };
  const titleHasHtml = /<\/?[a-z][\s\S]*>/i.test(data?.title || "");

  return (
    <section className="font-manrope max-w-7xl mx-auto lg:px-8 md:px-12 px-4 lg:py-0 md:pt-10 py-5 grid grid-cols-1 lg:grid-cols-2 xl:gap-20 lg:gap-10 gap-14 items-center">
      <div className="">
        {titleHasHtml ? (
          <div
            className="xl:text-5xl md:text-4xl text-3xl font-extrabold mb-4"
            dangerouslySetInnerHTML={{ __html: data?.title }}
          />
        ) : (
          <h2 className="xl:text-5xl md:text-4xl text-3xl font-extrabold mb-4">
            <span className="text-primary-red">{data?.title || "Connecting Skilled Talent"}</span>
          </h2>
        )}
        <p className="lg:pt-0 md:pt-2 text-primary-gray text-[16px] leading-7 font-medium">
          {data?.description ||
            "Since 1992, Nisa Travel Agency has been a trusted name in overseas recruitment, empowering individuals and supporting foreign employers across the GCC, Europe, Africa, and Asia."}
        </p>
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-3">
          <select
            className="w-full border border-[#25224A5C] px-3 py-2 bg-white"
            value={selectedCountry}
            onChange={(e) => setSelectedCountry(e.target.value)}
          >
            <option value="">Select Country</option>
            {countries.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
          <select
            className="w-full border border-[#25224A5C] px-3 py-2 bg-white"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            <option value="">Select Category</option>
            {categories.map((category) => (
              <option key={category.slug} value={category.name}>
                {category.name}
              </option>
            ))}
          </select>
        </div>
        <div className="flex gap-5 items-center pt-8 font-bold text-[18px]">
          <button
            type="button"
            onClick={handleApply}
            className="uppercase text-primary-white bg-primary-red px-6 py-2 "
          >
            Apply Filter
          </button>
          <button
            type="button"
            onClick={() => {
              setSelectedCountry("");
              setSelectedCategory("");
              onApplyFilters?.({ country: "", category: "" });
            }}
            className="text-primary-navyblue"
          >
            Reset
          </button>
        </div>
      </div>
      <img
        src={data?.image_url || familyImg}
        alt="Happy Family"
        className=" lg:w-full md:w-[500px] w-full mx-auto"
      />
    </section>
  );
};

export default GlobalOpportunities;
